(function(angular){
	'use strict';
	
	angular.module('yieldComparisonChartModule', [
		'BaseConfig', 
		'highChartsModule',
		'planModule'
	]);

})(window.angular);